export default "__VITE_ASSET__Doh$GnuE__"